import { initialState as initialOrderState } from '../slices/order';
import { initialState as initialProductState } from '../slices/product';
import { initialState as initialAuthState } from '../slices/auth';
import { initialState as initialTransactionState } from '../slices/transaction';
import { initialState as initialPayoutState } from '../slices/payout';
import { initialState as initialSidebarState } from '../slices/sidebar';

const migrations = {
  root: {
    1: (state) => {
      return {
        ...state,
        order: initialOrderState,
        product: initialProductState,
      };
    },
    2: (state) => {
      return {
        ...state,
        auth: initialAuthState,
      };
    },
    3: (state) => {
      return state;
    },
    5: (state) => {
      return undefined;
    },
    6: (state) => {
      return {
        ...state,
        transaction: initialTransactionState,
      };
    },
    7: (state) => {
      return {
        ...state,
        payout: initialPayoutState,
      };
    },
    8: (state) => {
      return {
        ...state,
        sidebar: initialSidebarState,
      };
    },
  },
  checkout: {
    1: (state) => {
      return undefined;
    },
  },
  payout: {
    2: (state) => {
      return initialPayoutState;
    },
  },
  webhook: {
    1: (state) => {
      return undefined;
    },
  },
};

export default migrations;
